import { ReportingAccessLevels } from '../../../../NonReact/constants/Permissions'
import { StandardOptionGroup } from '../../../Common/Components/Selects/GroupedSelect/GroupedSelect'
import { PreferredReportingAccessLevel } from '../../Types'

/**
 * Chooses the first preferred reporting level that is currently available in the reporting options.
 *
 * @param reportingLevelOptions - Grouped reporting-level options currently available to the form.
 * @param preferredReportingAccessLevels - Ordered preferred levels to try.
 * @returns The first matching preferred level, or {@link ReportingAccessLevels.NONE} if none are available.
 */
export const selectPreferredReportingAccessLevel = (
    reportingLevelOptions: Nullable<StandardOptionGroup>[],
    preferredReportingAccessLevels?: PreferredReportingAccessLevel[]
): ReportingAccessLevels => {
    const availableReportingLevels: string[] = reportingLevelOptions.flatMap(
        (reportingGroup: Nullable<StandardOptionGroup>): string[] =>
            reportingGroup?.options?.map((reportingLevelOption): string => String(reportingLevelOption.value)) ?? []
    )

    return (
        preferredReportingAccessLevels?.find((reportingLevel: PreferredReportingAccessLevel): boolean =>
            availableReportingLevels.includes(reportingLevel)
        ) ?? ReportingAccessLevels.NONE
    )
}
